import { useEffect, useState } from "react";
import AsideV2 from "../../../components/asidev2/AsideV2";
import "../home/Styles.css";
import { styled } from "styled-components";
import {
  deleteFlag,
  getFlagsByMonthAndYear,
  setFlagToApproved,
  setFlagToPending
} from "../../../hooks/firebase";
import { RxReload } from "react-icons/rx";
import { FaTrash } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import HeaderV2 from "../../../components/adminV2/header/Header";


const WrapperCard = styled.div`
  width: 50%;
  background-color: white;
  margin-top: 20px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.08);

  .image {
    width: 100%;
    height: 200px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .property-data {
    padding: 20px;
    background-color: white;
    color: #111;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .top {
      display: flex;
      flex-direction: column;
    }

    .actions {
      display: flex;
      gap: 10px;
      margin-top: 10px;

      .action {
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        padding: 15px;
        border-radius: 12px;
        color: white;
      }

      .reload {
        background-color: #ffd700;
      }

      .delete {
        background-color: #e57373;
      }

      .approve {
        background-color: #4caf50;
      }

      .disabled {
        background-color: #6d6d6d;
        cursor: not-allowed;
      }
    }
  }
`;


export default function FlagsV2() {
  const today = new Date();
  const months = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);
  const currentMonth = months[today.getMonth()];
  const currentYear = today.getFullYear();

  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [data, setData] = useState(null);

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "Data inválida";

    const date = timestamp.toDate();
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).format(date);
  };

  const translateStatus = (status) => {
    if (status === "pending") return "Pendente";
    if (status === "approved") return "Aprovada";
    return status;
  };

  const handleDeleteFlag = async (flagId) => {
    await deleteFlag(flagId);
    const newData = data.filter(report => report.id !== flagId);
    setData(newData);
  };

  const handleUpdateFlagToPending = async (flagId) => {
    await setFlagToPending(flagId);
    const newData = data.map(report => {
      if (report.id === flagId) return { ...report, status: "pending" };
      return report;
    });
    setData(newData);
  };

  const handleUpdateFlagToApprove = async (flagId) => {
    await setFlagToApproved(flagId);
    const newData = data.map(report => {
      if (report.id === flagId) return { ...report, status: "approved" };
      return report;
    });
    setData(newData);
  };

  useEffect(() => {
    const monthNumber = months.indexOf(month) + 1;
    async function load() {
      let result = await getFlagsByMonthAndYear(monthNumber, year);
      setData(result);
    }
    load();
  }, [month, year]);

  return (
    <div>
      <AsideV2 />
      <main className="main-wrapper">
        <HeaderV2 />

        <section className="section">
          <div className="container-fluid mt-30">
            <div className="row">
              <div className="col-12 d-flex justify-content-between align-items-center mb-4">
                <h2>Denúncias</h2>
                <div className="d-flex gap-2">
                  <select value={month} onChange={(e) => setMonth(e.target.value)}>
                    {months.map((m) => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </select>
                  <select value={year} onChange={(e) => setYear(e.target.value)}>
                    {years.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </select>
                </div>
              </div>

              {data && data.map((report) => (
                <div key={report.id} className="col-xl-6 col-lg-6 col-md-12">
                  <WrapperCard>
                    <a className="image" href={`/imovel/${report.property}`} target="_blank" rel="noopener noreferrer">
                      <img src={report.propertyImage} alt={`Imagem do imóvel ${report.property}`} />
                    </a>
                    <div className="property-data">
                      <div className="top">
                        <span className="line">
                          Denunciante: <strong>{report.reporter}</strong>
                        </span>
                        <span className="line">
                          Momento da Denúncia: <strong>{formatTimestamp(report.moment)}</strong>
                        </span>
                        <span className="line">
                          Status: <strong>{translateStatus(report.status)}</strong>
                        </span>
                      </div>
                      <div className="actions">
                        {report.status === "approved" ? (
                          <div className="action reload" onClick={() => handleUpdateFlagToPending(report.id)}>
                            <RxReload />
                          </div>
                        ) : (
                          <div className="action disabled">
                            <RxReload />
                          </div>
                        )}

                        <div className="action delete" onClick={() => handleDeleteFlag(report.id)}>
                          <FaTrash />
                        </div>

                        {report.status === "pending" ? (
                          <div className="action approve" onClick={() => handleUpdateFlagToApprove(report.id)}>
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="action disabled">
                            <FaCheck />
                          </div>
                        )}
                      </div>
                    </div>
                  </WrapperCard>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
